import React from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const WmsTabContent = ({ lines, onDeleteLine }) => {
  return (
    <Box sx={{ px: 1, pb: 1, pt: 3 }}>
      <Box
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          p: 1.5,
          bgcolor: 'grey.100',
          mt: 1.5,
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          Tételek
        </Typography>
        <Stack spacing={1} sx={{ mt: 1 }}>
          {lines.map((line, index) => {
            const lineKey = line?.id ?? `${line?.itemCode || 'line'}-${index}`;
            const qty = Number(line?.qty ?? line?.quantity ?? 0) || 0;
            const unitCode = line?.quantityUnitCode ?? line?.quantityUnit?.code ?? '';
            const itemName = line?.itemName ?? line?.item?.itemName ?? '';

            return (
              <Box
                key={lineKey}
                sx={{
                  px: 1.5,
                  py: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  bgcolor: 'white',
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: 1,
                }}
              >
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="subtitle2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
                    {line?.itemCode || '-'} {itemName ? `- ${itemName}` : ''}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.25 }}>
                    Mennyiség: {qty} {unitCode}
                  </Typography>
                  {line?.batchSn ? (
                    <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.25 }}>
                      Sarzs: {line.batchSn}
                    </Typography>
                  ) : null}
                  {line?.binCode ? (
                    <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.25 }}>
                      Rakhely: {line.binCode}
                    </Typography>
                  ) : null}
                </Box>

                <IconButton color="error" size="small" aria-label="Törlés" onClick={() => onDeleteLine(line)}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Box>
            );
          })}

          {lines.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              Nincs még rögzített tétel.
            </Typography>
          ) : null}
        </Stack>
      </Box>
    </Box>
  );
};

export default WmsTabContent;
